<template>
  <div class="yxxsc" v-if="kbxmlc" v-loading="waitLoading">
    <template v-if="role == 'Z'">
      <div :class="['box', isProcessFinish || !isChose ? 'noBtn' : '']">
        <p class="cont-title">有效性审查</p>
        <div class="ddscBox">
          <div v-if="!isChose">
            <div class="scfs-title">已准备就绪，请开始审查</div>
            <div>
              <el-button type="primary" @click="handleSelectNewReviewWay">确定</el-button>
            </div>
          </div>
          <template v-else>
            <h2 v-if="sfqrscjg">审查已完成，请各投标单位自行查看审查结果！</h2>
            <h2 v-else>请等待审查结束！</h2>
          </template>
        </div>
      </div>
      <el-button
        type="primary lcNext"
        :disabled="!sfqrscjg || waitLoading"
        @click="nextBtn"
        v-if="!isProcessFinish && isChose"
        >下一步</el-button
      >
    </template>
    <div class="box noBtn" v-else>
      <div class="clear">
        <p class="cont-title lf">有效性审查</p>
        <div class="rt">
          <el-select
            v-model="sfjnbzj"
            placeholder="保证金"
            style="width: 100px; float: left"
            @change="serachData"
          >
            <el-option
              v-for="item in sfjnbzjOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="kbsczt"
            placeholder="审查结果"
            style="width: 100px; float: left; margin-left: 10px"
            @change="serachData"
          >
            <el-option
              v-for="item in kbscztOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-input
            v-model="tbdwmc"
            class="input-with-select lf"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="serachData"
            ></el-button>
          </el-input>
          <el-button
            v-if="role == 'T' || role == 'A'"
            type="primary"
            @click="qdsc"
            :disabled="isProcessFinish || !sfscws || sfqrscjg || isValidityReviewOpen"
          >确定</el-button>
          <el-button
            v-if="role == 'T' || role == 'A'"
            type="primary"
            @click="handleReExamine"
            :disabled="isProcessFinish || sfqrscjg || isValidityReviewOpen"
          >全部重新审查</el-button>
          <el-button
            v-if="role == 'T' || role == 'A'"
            type="primary"
            @click="handleReviewHistorical"
          >历史记录</el-button>
        </div>
      </div>
      <el-table
        ref="table"
        v-loading="tableLoading"
        @selection-change="handleSelectionChange"
        border
        :data="tableData"
        style="width: 100%"
        height="500"
      >
        <el-table-column
          type="selection"
          width="40"
          fixed="left"
        ></el-table-column>
        <el-table-column label="序号" width="50" fixed="left">
          <template slot-scope="scope">
            {{
              currentPage
                ? (currentPage - 1) * pageSize +
                  scope.$index +
                  1
                : scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="fCQYMC"
          label="投标单位名称"
          show-overflow-tooltip
          min-width="180"
          fixed="left"
        >
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <p>{{ scope.row.FCQYMC }}</p>
              <div
                v-if="scope.row.lhtShowOrNo == 1"
                style="margin-left: 20px"
                class="btn-lht"
                @click="openLht(scope.row.lhtId)"
              >
                联合体
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="qdsj"
          label="签到时间"
          sortable
          width="160"
          :formatter="formatter"
        ></el-table-column>
        <el-table-column
          prop="FDBSSCSJ"
          label="投标文件递交时间"
          sortable
          width="160"
        ></el-table-column>
        <el-table-column
          prop="jnfs"
          label="缴纳方式"
          width="80"
        >
          <template slot-scope="{ row }">
            <div>
              <p>{{ paidMethodName(row.jnfs) }}</p>
            </div>
          </template>
        </el-table-column> 
        <el-table-column
          prop="sfjnbzj"
          label="缴纳状态"
          width="80"
        >
          <template slot-scope="{ row }">
            <div
              :class="{
                'is-paid': row.sfjnbzj == 1,
                'not-paid': row.sfjnbzj != 1,
              }">
              <p>{{ paidStatusName(row.sfjnbzj) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="kbsczt"
          label="审查结果"
          width="80"
        >
          <template slot-scope="{ row }">
            <div>
              <p>{{ reviewResultName(row.kbsczt) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="bz"
          label="备注"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="cqbh"
          v-if="showCqbh"
          label="抽签编号"
          fixed="right"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.cqbh ? scope.row.cqbh : "待生成" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="{row}">
            <el-button
              v-if="showRevisionReviewButton(row)"
              :disabled="isValidityReviewOpen"
              type="text" 
              @click="handleRevisionReview(row)"
            >修改</el-button>
            <el-button
              v-if="showLookReviewButton(row)"
              type="text"
              @click="handleLookReview(row)"
            >查看</el-button>
            <el-button
              v-if="showReReviewButton(row)"
              :disabled="isValidityReviewOpen"
              type="text"
              @click="handleReReview(row)"
            >重新审查</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :pageSize="pageSize"
        :currentPage="currentPage"
        @changePage="changePage"
        @changePages="changePages"
      />
      <div class="clear">
        <span class="lf pageNum">
          共审查{{ total }}家，审查通过{{ sctg }}家，未通过{{
            scbtg
          }}家；待审查{{ total - sctg - scbtg }}家。
        </span>
      </div>
      <!-- 审查弹窗 -->
      <el-dialog
        title="审查"
        :visible.sync="dialogFormVisible"
        width="600px"
        :before-close="cancleForm"
        :close-on-click-modal="false"
      >
        <el-form :model="form" ref="form" label-width="100px" :rules="rules">
          <el-form-item label="缴纳保证金" prop="sfjnbzj">
            <el-radio-group v-model="form.sfjnbzj">
              <el-radio
                v-for="item in isPaidOptions"
                :key="item.value"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="缴纳方式" prop="jnfs">
            <el-radio-group v-model="form.jnfs">
              <el-radio
                v-for="item in paidMethodOptions"
                :key="item.value"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审查结果" prop="kbsczt">
            <el-radio-group v-model="form.kbsczt">
              <el-radio
                v-for="item in reviewResultOptions"
                :key="item.value"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="bz">
            <el-input type="textarea" v-model="form.bz"></el-input>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button type="primary" @click="handleRevisionReviewSubmit">提交</el-button>
        </div>
      </el-dialog>
      <lht-mark
        v-if="lhtVisible"
        :visible.sync="lhtVisible"
        :lhtId="lhtId"
      ></lht-mark>
      <el-dialog
        title="历史记录"
        width="1220px"
        :visible.sync="historyRecordVisible"
        :close-on-click-modal="false"
      >
        <ReviewModificationRecordTable :bdId="bdId" v-if="historyRecordVisible"></ReviewModificationRecordTable>
      </el-dialog>
    </div>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import lhtMark from "@/components/lhtMark/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import ReviewModificationRecordTable from "./components/ReviewModificationRecordTable.vue";

// 配置项
// 是否缴纳
const isPaidConfig = {
  notPaid: { KEY: 0, NAME: "未缴纳" },
  isPaid: { KEY: 1, NAME: "已缴纳"},
  notRequiresPaid: { KEY: 2, NAME: "未按要求缴纳"},
}
// 缴纳方式
const paidMethodConfig = {
  notGet: { KEY: 0, NAME: "暂未获取", disabledOptions: true },
  deposit: { KEY: 1, NAME: "保证金" },
  guarantee: { KEY: 2, NAME: "保函" },
  other: { KEY: 3, NAME: "其他" },
  offlineGuarantee: { KEY: 4, NAME: "线下保函" },
}
// 审查结果
const reviewResultConfig = {
  notReviewed: { KEY: "0", NAME: "未审查", disabledOptions: true },
  pass: { KEY: "1", NAME: "通过" },
  notPass: { KEY: "2", NAME: "不通过" },
}
// 有效性审查是否开启
const isValidityReviewConfig = {
  notOpen: { KEY: 0, NAME: "未开启" },
  open: { KEY: 1, NAME: "已开启" },
}
// 配置项使用方法
 export const transformMap = (dictionary) => {
  return Object.values(dictionary).reduce((result, status) => {
    result[status["KEY"]] = status["NAME"];
    return result;
  }, {});
}
export const transformOptions = (dictionary) => {
  return Object.values(dictionary).reduce((result, status) => {
    if (status.disabledOptions) return [...result];
    const option = {
      label: status["NAME"],
      value: status["KEY"],
    }
    return [...result, option];
  }, []);
}

export default {
  name: "yxxsc",
  components: {
    Pagination,
    lhtMark,
    ReviewModificationRecordTable,
  },
  data() {
    var _this = this;
    var myValidate = function (rule, value, callback) {
      if (_this.form.kbsczt == 2 && value == "") {
        callback(new Error("必填项"));
      } else {
        callback();
      }
    };
    var myValidate2 = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("必填项"));
      } else {
        _this.$refs.form.validateField("bz");
        callback();
      }
    };
    return {
      tableLoading: false,
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", //当前节点状态
      tableData: [],
      sctg: 0,
      scbtg: 0,
      tbdwmc: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      multipleSelection: [], //表格选择
      kbscztOptions: [
        { value: "qb", text: "全部" },
        { value: "1", text: "通过" },
        { value: "2", text: "不通过" },
        { value: "0", text: "待审查" },
      ],
      kbsczt: "",
      sfjnbzjOptions: [
        { value: "qb", text: "全部" },
        { value: "1", text: "已缴纳" },
        { value: "0", text: "未缴纳" },
        { value: "2", text: "未按要求缴纳" },
      ],
      sfjnbzj: "",
      dialogFormVisible: false,
      form: {},
      rules: {
        sfjnbzj: [{ required: true, message: "必填项", trigger: "change" }],
        jnfs: [{ required: true, message: "必填项", trigger: "change" }],
        kbsczt: [{ validator: myValidate2, required: true, trigger: "change" }],
        bz: [{ validator: myValidate, trigger: "blur" }],
      },
      flag: false,
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      scfs: "1", //审查方式
      isChose: false, //是否已经选择审查方式
      sfscws: false, //是否已经完成审查
      sfqrscjg: false,
      lhtVisible: false,
      lhtId: "",
      showCqbh: false,
      zbxmkpfs: sessionStorage.getItem("zbxmkpfs"),
      bdId: "",
      isPaidOptions: transformOptions(isPaidConfig),
      paidMethodOptions: transformOptions(paidMethodConfig),
      reviewResultOptions: transformOptions(reviewResultConfig),
      historyRecordVisible: false,
      yxxscsfkq: 0,
    };
  },
  computed: {
    // 当前流程节点是否完成
    isProcessFinish() {
      return this.kbxmlc.zt == "2";
    },
    // 有效性审查是否开启
    isValidityReviewOpen() {
      return this.yxxscsfkq == isValidityReviewConfig["notOpen"]["KEY"];
    }
  },
  methods: {
    openLht(id) {
      this.lhtVisible = true;
      this.lhtId = id;
    },
    getData() {
      let para = {
        djlcId: this.djlcId,
        tbdwmc: this.tbdwmc,
        kbsczt: this.kbsczt,
        sfjnbzj: this.sfjnbzj,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      this.waitLoading = true;
      this.$api
        .yxxsc(para)
        .then((res) => {
          if (res.data.meta.success) {
            console.log("ss", res.data.data.tbdwList);
            this.bdId = res.data.data.kbxm.bdId;
            this.tableData = res.data.data.tbdwList;
            this.total = res.data.data.total;
            this.sctg = res.data.data.sctgSize;
            this.scbtg = res.data.data.scwtgSize;
            this.showCqbh = res.data.data.kbxm.showCqbh;
            this.yxxscsfkq = res.data.data.kbxm.yxxscsfkq;
            if (res.data.data.kbxm.scfs) {
              
              this.scfs = res.data.data.kbxm.scfs;
              this.sfqrscjg =
                res.data.data.kbxm.yxxscsfqr == "1" ? true : false;
              this.isChose = true;
              this.sfscws = res.data.data.yxxscSfwc; //已经审查完成可以确认
            } else {
              this.isChose = false;
            }
            this.kbxmlc = res.data.data.kbxmlc;
            if (Number(this.zbxmkpfs) === 10) {
              if (!this.isChose) {
                this.saveScfs();
              } else {
                this.waitLoading = false;
              }
            }
            this.waitLoading = false;
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {});
    },
    //查询
    serachData() {
      this.getData();
    },
    changePages(val) {
      this.pageSize = val;
      this.getData();
    },
    changePage(val) {
      this.currentPage = val;
      this.getData();
    },
    saveScfs() {
      let para = {
        scfs: this.scfs,
      };
      this.waitLoading = true;
      this.$api
        .saveScfs(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.isChose = true;
            if (this.scfs == 1) {
              this.sfqrscjg = true;
              let obj = {
                lx: "zb",
                data: {},
              };
              this.$emit("send", JSON.stringify(obj));
            } else {
              this.sfqrscjg = false;
              let obj = {
                lx: "zbr",
                data: {},
              };
              this.$emit("send", JSON.stringify(obj));
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    cancleForm() {
      this.form = {
        sfjnbzj: "",
        jnfs: "",
        kbsczt: "",
        bz: "",
      };
      this.$refs.form.resetFields();
      this.dialogFormVisible = false;
      this.flag = false;
    },
    //确定审查全部完成，通知主持人，可以下一步操作
    qdsc() {
      this.$confirm("是否确认提交审查结果？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let para = {};
          this.waitLoading = true;
          this.$api
            .qdscjg(para)
            .then((res) => {
              if (res.data.meta.success) {
                let obj = {
                  lx: "kbzcr",
                  data: {},
                };
                this.$emit("send", JSON.stringify(obj));
                this.getData();
                this.sfqrscjg = true;
              }
              this.waitLoading = false;
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    formatter(row, column, cellValue, index) {
      if (row.qdsj) {
        return this.$moment(row.qdsj).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    // 缴纳状态
    paidStatusName(value) {
      const isPaidMap = transformMap(isPaidConfig);
      return isPaidMap[value] ?? '';
    },
    // 审查结果
    reviewResultName(value) {
      const reviewResultMap = transformMap(reviewResultConfig);
      return reviewResultMap[value] ?? '';
    },
    // 缴纳方式
    paidMethodName(value) {
      const paidMethodMap = transformMap(paidMethodConfig);
      return paidMethodMap[value] ??  '';
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    nextBtn() {
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.waitLoading = true;
      this.$emit("nextBtn", para);
    },

    // #region 权限判断函数
    showRevisionReviewButton(row) {
      // 节点未完成或未确认
      return !this.isProcessFinish && !this.sfqrscjg;
    },
    showLookReviewButton(row) {
      // 线下保函展示该节点
      return row.jnfs == paidMethodConfig["offlineGuarantee"]["KEY"];
    },
    showReReviewButton(row) {
      // 节点未完成或未确认
      return !this.isProcessFinish &&!this.sfqrscjg;
    },
    // #endregion

    // #region 功能函数
    // 选择审查方式（新接口，不含龙游）
    async handleSelectNewReviewWay(val) {
      try {
        const para = {
          scfs: this.scfs,
        };
        this.waitLoading = true;
        const res = await this.$api.saveYxxscScfsNew(para);
        if (res.data.meta.success) {
          this.waitLoading = false;
          this.isChose = true;
          if (this.scfs == 1) {
            this.sfqrscjg = true;
            let obj = {
              lx: "zb",
              data: {},
            };
            this.$emit("send", JSON.stringify(obj));
          } else {
            this.sfqrscjg = false;
            let obj = {
              lx: "zbr",
              data: {},
            };
            this.$emit("send", JSON.stringify(obj));
          }
        } else {
          this.waitLoading = false;
          this.$message.error(res.data.meta.message);
        }
      } catch (error) {
        this.waitLoading = false;
        this.$message.error(error.message);
      }
    },
    // 全部重新审查
    async handleReExamine() {
      try {
        this.waitLoading = true;
        const res = await this.$api.reReview();
        if (res.data.meta.success) {
          this.waitLoading = false;
          this.getData();
          this.$message.success("全部重新审查成功！");
        }
      } catch (error) {
        this.waitLoading = false;
        this.$message.error("全部重新审查失败");
      }
    },
    // 审查历史记录
    handleReviewHistorical() {
      this.historyRecordVisible = true;
    },
    // 修改审查
    handleRevisionReview(row) {
      this.dialogFormVisible = true;
      this.form = {
        sfjnbzj: row.sfjnbzj,
        jnfs: row.jnfs,
        kbsczt: row.kbsczt,
        bz: row.bz,
        id: row.id,
      };
    },
    // 修改审查提交
    async handleRevisionReviewSubmit() {
      try {
        const params = {
          id: this.form.id,
          reviewStatus: this.form.kbsczt,
          paymentMode: this.form.jnfs,
          depositPayState: this.form.sfjnbzj,
          remarks: this.form.bz,
        };
        this.waitLoading = true;
        const res = await this.$api.updateValidityReview(params);
        this.waitLoading = false;
        if (res.data.meta.success) {
          this.dialogFormVisible = false;
          this.getData();
          this.$message.success("修改审查提交成功！");
          this.$refs.form.resetFields();
        } else {
          this.$message.error(res.data.meta.message);
        }
      } catch (error) {
        this.waitLoading = false;
        this.$message.error("修改审查失败");
      }
    },
    // 查看审查结果(线下保函)
    async handleLookReview(row) {
      try {
        // 获取文件
        const res = await this.$api.viewFile({
          bidfilesId: row.XXBHFJ,
        });
        // 解析文件
        const contentDisposition = res.headers['content-disposition'];
        const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (!fileNameMatch) {
          this.$message.error('文件名获取失败');
          return;
        }
        const fileName = fileNameMatch[1].replace(/['"]/g, '');
        const fileNameArr = fileName.split('.');
        const type = fileNameArr[fileNameArr.length - 1];
        let fileType = "";
        if (type === "pdf") {
          fileType = "application/pdf";
        } else if (type === 'jpg' || type === 'jpeg') {
          fileType = 'image/jpeg';
        } else if (type === 'png') {
          fileType = 'image/png';
        }
        // 创建文件blob
        const blob = new Blob([res.data], {
          type: `${fileType};chartset=UTF-8`,
        });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      } catch (err) {
        console.log(err);
        this.$message({
          message: err.statusText,
          type: "error",
        });
      }
    },
    // 重新审查
    async handleReReview(row) {
      try {
        const params = {
          tbdwId: row.id,
        };
        this.waitLoading = true;
        const res = await this.$api.reReview(params);
        if (res.data.meta.success) {
          this.waitLoading = false;
          this.getData();
          this.$message.success("重新审查成功！");
        }
      } catch (error) {
        this.waitLoading = false;
        this.$message.error("重新审查失败");
      }
    }
    // #endregion
  },
  // inject: ["showCqbh"],
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
};
</script>
<style lang="less">
.yxxsc {
  .box {
    position: relative;
  }
  .msgBox {
    padding: 60px 80px 60px 100px;
    background: url("../assets/images/warning.png") no-repeat 40px 60px;
    h3 {
      font-size: 30px;
      color: #333;
      font-weight: 400;
      margin-bottom: 5px;
    }
    p {
      font-size: 16px;
      color: #333;
      span {
        color: @base-color;
        font-size: 24px;
      }
    }
  }
  .ddscBox {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h2 {
      font-size: 36px;
      color: #333;
    }
    div {
      p {
        font-size: 18px;
        color: #333;
        margin-bottom: 60px;
      }
      .el-button {
        width: 180px;
        height: 42px;
        line-height: 42px;
      }
      div.scfsBtn {
        margin-bottom: 100px;
        button {
          width: 250px;
          height: 60px;
          line-height: 60px;
          padding: 0;
          margin: 0 10px;
          font-size: 20px;
          color: @base-color;
          background: #fff;
          border: 1px solid @base-color !important;
        }
        button.active {
          background: @base-color;
          color: #fff;
          font-weight: bold;
        }
      }
      div.scfs-title {
        margin-bottom: 100px;
        color: #000;
        font-size: 20px;
        font-weight: bolder;
      }
    }
  }
  .el-table {
    .not-paid {
      color: #FC0000;
    }
    .is-paid {
      color: #009900;
    }
    .el-button.el-button--text {
      color: #D9001B;
      text-decoration: none;
    }
  }
}
</style>
